const EmbedCode = ({ fill = '#fff' }) => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 7L5 15L11 23M19 7L25 15L19 23"
            stroke={fill}
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default EmbedCode;
